import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import CurrencyInput from "../../../../components/inputs/currency";
import NumberInput from "../../../../components/inputs/number";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({ isOpenModalRegister, ident, idTable, selectedData, setSelectData, fetchID, reloadData, insert }) => {
	const {
		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		loading,

		//formState
		errors,
		isSubmitting,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(
						handleOnSubmit
						// handleOnError
					)}
				>
					<main>
						<div className="row">
							<TextInput
								label="Banco"
								id="banco"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
								className="col-12"
							/>
							<TextInput
								label="Agência"
								id="ag"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
							/>
							<TextInput
								label="Conta Corrente"
								id="cc"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
							/>
							<CurrencyInput
								label="Saldo"
								name="saldo"
								control={control}
								errors={errors}
								placeholder="Digite o preço"
								required={true}
								decimalScale={2}
								prefix="R$ "
								className={`col-12 col-sm-6 col-lg-3`}
							/>
							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_bank"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_bank">
										<span className="text-lg">Ativar Banco</span>
									</label>
								</div>
							</div>
						</div>
					</main>
					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;
